import { render, staticRenderFns } from "./depreCiationSituation.vue?vue&type=template&id=fe35b34a&scoped=true&"
import script from "./depreCiationSituation.vue?vue&type=script&lang=js&"
export * from "./depreCiationSituation.vue?vue&type=script&lang=js&"
import style0 from "./depreCiationSituation.vue?vue&type=style&index=0&id=fe35b34a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe35b34a",
  null
  
)

export default component.exports